.bam-footer-nav-list {

  &.desktop:is-two-thirds {
    flex-direction: row !important;
    flex-wrap: wrap;
    justify-content: space-between;

    & > * {
      flex: unset !important;
      @include tablet {
        width: calc(50% - 16px) !important;
      }
    }
  }
}
